import React from "react";
import Title from "../../Title/Title";
import {Grid} from "@mui/material";
import './ImmunoClustDemoPage.css';
import CustomHorizontalSpace from "../../Assistants/SpaceAssistant";
import IcapTitle from "../../Assistants/IcapTitle";
import Heading from "../../Assistants/Heading";
import InfoCard from "../../Cards/InfoCard";
import logo from "../../../resources/images/logo_500_500.png";
import OverviewImmunoClustProps from "../HomePage/OverviewImmunoClustProps";
import OverViewImmunoClustPropsColumn from "../HomePage/OverViewImmunoClustPropsColumn";
import {Colors} from "../../../resources/Colors";
import AnalysisSetting from "./AnalysisSetting";
import AnalysisSettingsColumn from "../../AnalysisSettings/AnalysisSettingsColumn";
import fcs from "../../Pages/ImmunoClustDemoPage/images/fcs.png";
import cluster from "../../Pages/ImmunoClustDemoPage/images/clustering.png";
import meta from "../../Pages/ImmunoClustDemoPage/images/meta.png";
import anno from "../../Pages/ImmunoClustDemoPage/images/anno1.png";
import quant from "../../Pages/ImmunoClustDemoPage/images/quantification.png";
import bg from "../../../resources/images/zellhaufen.png"

function ImmunoClustDemo() {
    return <>

        <Title title={'About iCAP'} img={bg}/>
        <CustomHorizontalSpace space={100}/>
        <Grid container className={'container--intro'}>
            <IcapTitle/>
        </Grid>
        <CustomHorizontalSpace space={100}/>
        <Grid container className={"headingContainer"}>
            <Heading title={'Problem & Solution'}/>
        </Grid>
        <CustomHorizontalSpace space={100}/>
        <Grid container className={"pAndSContainer"}>
            <Grid item xs={12} md={3}>
                <InfoCard iconClassName={"fa-solid fa-circle-xmark list-icon"} color={"#D71818"} title={'Problem'}
                          text={['Classic flow cytometry analysis using manual gating requires many user-specific decisions: it is time-consuming and not easily reproducible.',
                              'With increasing markers per test, the complexity of measurement and analysis increases significantly.']}/>
            </Grid>
            <Grid className={"logoContainer"} item xs={12} md={3}>
                <img src={logo} alt="Logo" width={"100px"}/>
            </Grid>
            <Grid item xs={12} md={3}>
                <InfoCard iconClassName={"fas fa-check-circle list-icon"} color={"#53BD57"} title={'Our Solution'}
                          text={["Modern adapted cluster algorithms enable reliable and reproducible population detection for flow cytometry data.", "A co-clustering algorithm with integrated normalization method leads to the detection of stable populations that are comparable across samples.",
                              "Co-clustering with an analysis model enables the sequential analysis of additional samples for diagnostics.",
                              "Cloud computing allows for high throughput of many samples."
                          ]}/>
            </Grid>
        </Grid>
        <Grid container className={'propsContainer'}>
            <Grid className="overviewProps">
                <OverviewImmunoClustProps/>
            </Grid>
            <Grid className="overviewPropsColumn">
                <OverViewImmunoClustPropsColumn/>
            </Grid>
        </Grid>
        <CustomHorizontalSpace space={100}/>
        <Grid container className={"shoutContainer"}>
            <h1 className={'shoutText'}>Fully automatic output of results using AI <i
                className={"fa-whiteboard fa-semibold fa-arrow-right"} style={{color: Colors.bioretisBlue}}></i> No
                group comparisons
            </h1>
        </Grid>
        <CustomHorizontalSpace space={200}/>
        <Grid container className={"headingContainer"}>
            <Heading title={'Set up and automated Analysis'}/>
        </Grid>
        <CustomHorizontalSpace space={100}/>
        <Grid container className={"analysisTable"}>
            <AnalysisSetting/>
        </Grid>
        <CustomHorizontalSpace space={100}/>
        <Grid container className={"analysisColumns"} direction={"column"}>
            <AnalysisSettingsColumn title={'Initial Set up for a defined staining protocol'}
                                    topText={"Staining and flow cytometry of blood cells from multiple samples of reference group (n=20 to 30)"}
                                    image={fcs} bg={"laboratory"}
                                    bottomTitle={"Automated analysis of individual samples"}
                                    bottomText={"Staining, flow cytometry of an individual sample and data upload by client i.e. clinical laboratory"}/>
            <i className={"fa-regular fa-arrow-down arrow-down"}></i>
            <AnalysisSettingsColumn title={'Initial Set up for a defined staining protocol'}
                                    topText={"AI-based automated multidimensional clustering of cells of each sample with immunoClust"}
                                    image={cluster} bg={"bioretis"}
                                    bottomTitle={"Automated analysis of individual samples"}
                                    bottomText={"Automated multidimensional clusteringof cells with AI-tool immunoClust"}/>
            <i className={"fa-regular fa-arrow-down arrow-down"}></i>
            <AnalysisSettingsColumn title={'Initial Set up for a defined staining protocol'}
                                    topText={"Meta-clustering of all populations from all samples to identify comparable clusters"}
                                    image={meta} bg={"bioretis"}
                                    bottomTitle={"Automated analysis of individual samples"}
                                    bottomText={"Automated Meta-clustering of all populations against reference model to identify annotated clusters"}/>
            <i className={"fa-regular fa-arrow-down arrow-down"}></i>
            <AnalysisSettingsColumn title={'Initial Set up for a defined staining protocol'}
                                    topText={"Annotation of relevant populations"} image={anno} bg={"bioretis"}
                                    bottomTitle={"Automated analysis of individual samples"} bottomText={""}/>
            <i className={"fa-regular fa-arrow-down arrow-down"}></i>
            <AnalysisSettingsColumn title={'Initial Set up for a defined staining protocol'}
                                    topText={"Quantification of cell types by absolute and relative numbers and definition of reference values"}
                                    image={quant} bg={"bioretis"}
                                    bottomTitle={"Automated analysis of individual samples"}
                                    bottomText={"Automated quantification of cell types by absolute and relative numbers and comparison to reference values"}/>
        </Grid>
        <CustomHorizontalSpace space={100}/>
        <Grid container className={"headingContainer"}>
            <Heading title={'Automated evaluation of cytometry data with iCAP'}/>
        </Grid>
        <CustomHorizontalSpace space={100}/>
        <Grid container direction={"column"} className={"desc-container"}>
            <Grid item className={"desc-info-item"} xs={12} md={6}>
                <InfoCard iconClassName={"fa-solid fa-circle-check list-icon"} title={'Advantages'}
                          text={["Developed especially for high-dimensional data sets (>10 markers / colors)",
                              "Requires only an “FCS” file and is independent of the cytometer/manufacturer\n",
                              "The calculation produces the same results when repeated for the same data set\n",
                              "No user-dependent variation due to manual gating or sample-dependent non-specific shifts in marker intensities\n",
                              "Automatic output of results showing quantitative deviations from reference values for cell count and variability of marker intensity in a population \n",
                              "Automatic detection of new/unclear populations by setting specific threshold values \n",
                              "Fully automated analysis of routine cytometry data from upload of „FCS“ files to output of results\n",
                              "No staff time required for grouping data   =  more time for informed interpretation of results\n",
                              "Extensive experience over several years through the evaluation of a cytometry-based cancer test\n"]}/>
            </Grid>
            <Grid item className={"desc-info-item"} xs={12} md={6} style={{alignSelf: "flex-end"}}>
                <InfoCard iconClassName={"fa-solid fa-circle-check list-icon"} title={'Prerequisite'}
                          text={["A defined staining protocol must be annotated and quantified once with a reference data set\n"]}/>
            </Grid>
            <Grid item className={"desc-info-item"} xs={12} md={6}>
                <InfoCard iconClassName={"fa-solid fa-circle-check list-icon"}
                          title={'What is currently immediately avaiable?'}
                          text={["Cloud computing solution for sequential calculation of complex flow cytometry data (single-cell clustering; population clustering)\n",
                              "Focus on fluorescence flow cytometry\n",
                              "Tools for dot plot output, population annotation, absolute and relative quantification of populations\n",
                              "Integration into the laboratory infrastructure via API interfaces for data exchange possible\n"]}/>
            </Grid>
            <Grid item className={"desc-info-item"} xs={12} md={6} style={{alignSelf: "flex-end"}}>
                <InfoCard iconClassName={"fa-solid fa-circle-check list-icon"}
                          title={'What still needs to be done?'}
                          text={["Obtaining individual requirements from the daily practice of a laboratory with FACS orders\n",
                              "Setup for a defined staining\n",
                              "User request for the output parameters \n"]}/>
            </Grid>
        </Grid>
        <CustomHorizontalSpace space={100}/>
        <Grid container className={"headingContainer"}>
            <Heading title={'Competition'}/>
        </Grid>

        <CustomHorizontalSpace space={100}/>
        <Grid container className={"desc-container"}>
            <Grid item className={"desc-info-item"} xs={12} md={6}>
                <InfoCard iconClassName={"fa-solid fa-circle-xmark list-icon"} title={'Competitors'} color={"#D71818"}
                          text={["Are more focused on research (group comparisons, etc.)",
                              "Do not offer complete automation and evaluation of individuell tests against a reference",
                              "Are not well optimized for population comparisons between diffrent samples",
                              "Software license instead of costs per sample"]}/>
            </Grid>
        </Grid>
        <Grid container className={"shoutContainer"}>
            <h1 className={'shoutText'}>Our Solution <i
                className={"fa-whiteboard fa-semibold fa-arrow-right"} style={{color: Colors.bioretisBlue}}></i> Full
                automation of individual sample analysis instead of user guided comparisons
            </h1>
        </Grid>


        <CustomHorizontalSpace space={100}/>
        <Grid container className={"headingContainer"}>
            <Heading title={'Summary'}/>
        </Grid>
        <CustomHorizontalSpace space={80}/>
        <Grid className={"summary-container"} >
            <Grid item xs={12} className={"summary-item-title"}>
                <h3 style={{color:"white"}}>
                    Our AI tool differs from all known developments in academic and industrial development in the following ways
                </h3>
            </Grid>
            <Grid className={"summary-item-row"} container>
                <Grid item xs={12} md={6} className={"summary-item"}>
                    <ul className={"custom-list"}>
                        <li>
                            <i className="fas fa-check-circle list-icon" style={{color:"white"}}></i>
                            <p style={{color:"white"}}>
                                Reliability and high specificity for diagnostic requirements for single sample measurements
                            </p>
                        </li>
                        <li>
                            <i className="fas fa-check-circle list-icon" style={{color:"white"}}></i>
                            <p style={{color:"white"}}>
                                Enormous safety advantage through automated, reproducible cell clustering and meta-clustering of populations against reference populations (manual evaluations can lead to user- or sample-dependent non-specific deviations of results due to user-dependent gating or fixed gating limits).

                            </p>
                        </li>
                        <li>
                            <i className="fas fa-check-circle list-icon" style={{color:"white"}}></i>
                            <p style={{color:"white"}}>
                                Tested in Cancer Screening Test with high specificity (≈80–85%) and high sensitivity (≈50–60%)
                            </p>
                        </li>
                        <li>
                            <i className="fas fa-check-circle list-icon" style={{color:"white"}}></i>
                            <p style={{color:"white"}}>
                                Reduction in staff time and costs, easier handling
                            </p>
                        </li>
                    </ul>
                </Grid>
                <Grid item xs={12} md={6} className={"summary-item"}>
                    <ul className={"custom-list"}>
                        <li>
                            <i className="fas fa-check-circle list-icon" style={{color:"white"}}></i>
                            <p style={{color:"white"}}>
                                No group comparisons as in research, but individual sample analysis compared to references for clinical use.
                            </p>
                        </li>
                        <li>
                            <i className="fas fa-check-circle list-icon" style={{color:"white"}}></i>
                            <p style={{color:"white"}}>
                                Significantly improved results in flow cytometry diagnostics
                            </p>
                        </li>
                        <li>
                            <i className="fas fa-check-circle list-icon" style={{color:"white"}}></i>
                            <p style={{color:"white"}}>
                                Proof of concept through cancer screening test in early marketing since 2017
                            </p>
                        </li>
                        <li>
                            <i className="fas fa-check-circle list-icon" style={{color:"white"}}></i>
                            <p style={{color:"white"}}>
                                Broad marketing in China from 2026
                            </p>
                        </li>
                        <li>
                            <i className="fas fa-check-circle list-icon" style={{color:"white"}}></i>
                            <p style={{color:"white"}}>
                                AI tool can be adapted quickly and easily for new applications (for other diagnoses and laboratory test applications)
                            </p>
                        </li>

                    </ul>
                </Grid>
            </Grid>

        </Grid>
        <CustomHorizontalSpace space={100}/>
    </>


}

export default ImmunoClustDemo